import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67385b6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-fanhui" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-paixu" })
], -1))

import {ref, watch, onMounted, computed, nextTick} from 'vue';
import {Tabs, Tab} from 'vant';
import {useRouter} from 'vue-router';
import TitleBar from '@/components/TitleBar.vue';
import {useAreaList, useAllList} from '@/service/info';
import {closeWindow, reportLog} from '@/bridge/index';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import useUa from '@/hooks/useUa';
import {haboClickReport} from '@/plugins/haboConfig';
import {useTagInfo} from '@/hooks/useTagInfo';
import {TAB_KEY_MAP} from '@/enum/constant';
import useTimeReport from '@/hooks/useTimeReport';
import {useNPSPopup} from '@/hooks/useNPSPopup';
import AreaPicker from './AreaPicker/index.vue';
import TabContent from './TabContent/index.vue';

// active tag, tag list, 是否展示地区按钮

const __default__ = {
  name: 'Info',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "12c0e84f": (showTabsWrapVisibility.value)
}))

const {tagId, tagIdList, hasAreaQuery} = useTagInfo();
const {isXApp} = useUa();
const back = useNPSPopup();
const hasArea = computed(() => hasAreaQuery || isXApp.isGongkaoApp);


const initTagId = ref<number>(tagId || TAB_KEY_MAP.recommend);

// 记录已经渲染过的 tab. 控制每个 tab 下的内容初次渲染, 因为 swiperable 的 tab 默认会加载出所有 tab 下的内容
const renderedTabArr = ref<number[]>([]);
const pushRenderedTab = (tabId: number) => {
  renderedTabArr.value.push(tabId);
};

const tabActive = ref<number>(tagId ? tagId : TAB_KEY_MAP.recommend);// v-model 绑定的初始 active tab
// 记录第一次渲染的状态, 第一次渲染仅请求当前 active 的 tab. 这么处理是因为组件库会把前面的无关 tab 数据也请求
const animateDuration = ref<number>(0.3);
watch(tabActive, (curTab: number, preTab: number) => {
  // 根据 tab 切换设置动画时长
  const curTabIndex = tabObjList.value.findIndex(
    (item: { tagName: string; tagId: number }) => item.tagId === curTab
  );
  const preTabIndex = tabObjList.value.findIndex(
    (item: { tagName: string; tagId: number }) => item.tagId === preTab
  );
  if (Math.abs(curTabIndex - preTabIndex) > 1) {
    animateDuration.value = 0;
  }
  else {
    animateDuration.value = 0.3;
  }
});

// 控制 tab, 默认就有推荐和收藏
const tabObjList = ref<{ tagId: number; tagName: string }[]>(
  tagId
    ? [
      {tagId: TAB_KEY_MAP.recommend, tagName: '推荐'},
      ...tagIdList.map((item: number) => ({tagId: item, tagName: '...'})),
      {tagId: TAB_KEY_MAP.collect, tagName: '收藏'}
    ]
    : [
      {tagId: TAB_KEY_MAP.recommend, tagName: '推荐'},
      {tagId: TAB_KEY_MAP.collect, tagName: '收藏'}
    ]
);
const setTabObjList = (list: { tagId: number; tagName: string }[]) => {
  tabObjList.value = [
    {tagId: TAB_KEY_MAP.recommend, tagName: '推荐'},
    ...list,
    {tagId: TAB_KEY_MAP.collect, tagName: '收藏'},
  ];
};

// active tag, tag list, 是否展示地区按钮
const router = useRouter();
const categoryId = +router.currentRoute.value.query.cmsCode! as number;
// 请求标签信息, 和资讯品类名(展示 titlebar 标题)
const {
  data: tagList,
  execute: refetchTagList,
  isFinished,
  error,
} = useAllList({
  current: 1,
  pageSize: 1
}, {
  newsCategoryIds: [categoryId],
  h5TagIdList: tagIdList
}, 'tag', true);
// 如果标签请求错误, 需要重新请求标签
const ifRefetchTagList = () => {
  if (error.value) {
    refetchTagList();
  }
};
const infoTitle = ref<string>('资讯');
// tab 标题区域是否显示
const showTabsWrapVisibility = ref<string>('hidden');
// 是否上报过fmp
watch(isFinished, () => {
  if (isFinished.value && !error.value) {
    const list = tagList.value?.list?.[0]?.h5TagList ?? [];
    showTabsWrapVisibility.value = 'visible';
    setTabObjList(list);
    haboClickReport('CMS_TAG_EXPOSURE', {
      label_names: `[${list.map(item => item.tagName).toString()}]`
    });
    const title = tagList.value?.list?.[0]?.cmsCategoryName;
    if (title) {
      if (isXApp.isGongkaoApp) {// 公考不展示品类名
        document.title = '资讯';
        infoTitle.value = '资讯';
      }
      else {
        document.title = `资讯-${title}`;
        infoTitle.value = `资讯-${title}`;
      }
    }
    nextTick(() => {
      reportLog('fmp');
    });
  }
});

// 标签点击
const handleTabClick = (tabInfo: { name: number; title: string }) => {
  const {name: id, title} = tabInfo;// name 是标签 id, title 为标签名
  const tagIndex = (tagList.value?.list?.[0]?.h5TagList ?? []).findIndex(item => item.tagId === id);
  if (id === TAB_KEY_MAP.collect) {
    haboClickReport('COLLECT_TAB_CLICK', {});
  }
  else if (id !== TAB_KEY_MAP.recommend) {
    haboClickReport('CMS_TAG_CLICK', {
      label_name: title,
      label_idx: tagIndex,
    });
  }

};

// 获取 url 上的 statusBarHeight  高度
const {statusBarHeight} = useDeviceInfo();

// 请求地区选项和地区码
const {
  data: areaListData,
  execute: areaListRefetch,
  isFinished: areaFinished,
  isFetching: areaFetching,
  // error: areaError,
} = useAreaList(hasArea.value ? 'immediate' : 'manual');

// 记录地区 id 数组, 默认 0-全国
const areaIdList = ref<number[]>([0]);
const setAreaIdList = (list: number[]) => {
  areaIdList.value = list;
};
// titlebar 右上角显示的地区, 默认 '全国'
const curArea = ref<string>('全国');
const setCurArea = (cur: string) => {
  curArea.value = cur;
};
// 更新 localstorage
watch(areaIdList, () => {
  window.localStorage.setItem(
    'area_id_list',
    JSON.stringify(areaIdList.value.length ? areaIdList.value : [0]),
  );
});
watch(curArea, () => {
  window.localStorage.setItem('area_name_str', curArea.value || '全国');
});

onMounted(() => {
  // 如果高途 App 没有配置地区, 设置为全国
  if (!isXApp.isGongkaoApp && !hasAreaQuery) {
    window.localStorage.setItem('area_id_list', JSON.stringify([0]));
    window.localStorage.setItem('area_name_str', '全国');
    return;
  }
  // 首次从 localstorage 中取得上次存入的地区 id 列表和字符串, 默认 0-全国
  const preAreaIdList = JSON.parse(
    window.localStorage.getItem('area_id_list') || '[]',
  ) as number[];
  const preArea = window.localStorage.getItem('area_name_str');
  setAreaIdList(preAreaIdList.length ? preAreaIdList : [0]);
  setCurArea(preArea || '全国');

  haboClickReport('INFO_PAGE_EXPOSURE', {});
});

const handleBack = () => {
  closeWindow();
};

const showAreaPicker = ref<boolean>(false);
const toggleShowAreaPicker = (show: boolean) => {
  showAreaPicker.value = show;
};
// 点击选择地区
const handleAreaClick = () => {
  toggleShowAreaPicker(true);
  haboClickReport('AREA_BTN_CLICK');
};

useTimeReport('INFO_MAIN_PAGE_STAY_TIME');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "info-page",
    style: _normalizeStyle({ zIndex: _unref(router).currentRoute.value.name === 'info' ? 10 : 0 })
  }, [
    _createVNode(TitleBar, {
      title: infoTitle.value,
      "notice-bar-height": _unref(statusBarHeight)
    }, _createSlots({
      left: _withCtx(() => [
        (_openBlock(), _createElementBlock("svg", {
          class: "icon back-icon",
          "aria-hidden": "true",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(back) && _unref(back)(...args)))
        }, _hoisted_2))
      ]),
      _: 2
    }, [
      (
          _unref(isXApp).isGongkaoApp ||
            (_unref(hasAreaQuery) && _unref(areaFinished) && !_unref(areaFetching))
        )
        ? {
            name: "right",
            fn: _withCtx(() => [
              _createElementVNode("span", {
                class: "area-text",
                onClick: handleAreaClick
              }, [
                _createTextVNode(_toDisplayString(curArea.value) + " ", 1),
                _hoisted_3
              ])
            ])
          }
        : undefined
    ]), 1032, ["title", "notice-bar-height"]),
    _createVNode(AreaPicker, {
      show: showAreaPicker.value,
      "toggle-show-picker": toggleShowAreaPicker,
      "area-id-list": areaIdList.value,
      "set-cur-area": setCurArea,
      "area-list-data": _unref(areaListData) || [],
      "set-area-id-list": setAreaIdList,
      "area-list-refetch": _unref(areaListRefetch) || (() => {})
    }, null, 8, ["show", "area-id-list", "area-list-data", "area-list-refetch"]),
    _createVNode(_unref(Tabs), {
      active: tabActive.value,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((tabActive).value = $event)),
      "line-height": 3,
      "line-width": 16,
      ellipsis: false,
      duration: animateDuration.value,
      "lazy-render": "",
      swipeable: "",
      shrink: "",
      onClickTab: handleTabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabObjList.value, (item) => {
          return (_openBlock(), _createBlock(_unref(Tab), {
            key: item.tagId,
            title: item.tagName,
            name: item.tagId
          }, {
            default: _withCtx(() => [
              (renderedTabArr.value.includes(item.tagId) || item.tagId === tabActive.value)
                ? (_openBlock(), _createBlock(TabContent, {
                    key: 0,
                    "area-id-list": areaIdList.value,
                    "tab-id": item.tagId,
                    "cur-active-tab": tabActive.value,
                    "if-refetch-tag-list": ifRefetchTagList,
                    "tag-list-finished": _unref(isFinished),
                    "push-rendered-tab": pushRenderedTab,
                    "use-native": item.tagId === initTagId.value
                  }, null, 8, ["area-id-list", "tab-id", "cur-active-tab", "tag-list-finished", "use-native"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active", "duration"])
  ], 4))
}
}

})